
 /*
  *****************************************************************************
  * WARNING: This file is automatically generated.
  * Do not edit this file manually.
  *****************************************************************************
  *
  * The source file is located at:
  *   /codebuild/output/src2723206075/src/vl-app/pages/clinician/choose.tsx
  */

import { createFileRoute } from '@tanstack/react-router';
import { useState } from 'react';
import { useInitialisedStore } from '@hooks/useInitialisedStore';
import { useTranslation } from 'react-i18next';
import useBookingFlowData from 'vl-common/src/hooks/useBookingFlowData';
import { useQueryClient } from '@tanstack/react-query';
import router from '@hooks/useRouter';
import SelectClinicianSlotAndConfirmBooking from 'vl-common/src/components/BookAppointment/SelectClinicianSlotAndConfirmBooking';
import { SuccessModal } from 'vl-common/src/components/Modals';
import { appointmentBookedQueriesToInvalidate } from 'vl-common/src/lib/bookingQueryKeys';
import SuccessBookingMessage from 'vl-common/src/components/BookAppointment/SuccessBookingMessage';
import Header from '@components/Layouts/Header/Header';
import PageHead from '@components/Layouts/PageHead/PageHead';

const ClinicianChoose = () => {
  const { t } = useTranslation('common');
  const initialised = useInitialisedStore();
  const [confirmModalVisible, setConfirmModalVisible] = useState(false);
  const { bookingData } = useBookingFlowData();
  const queryClient = useQueryClient();

  const onSuccessBooking = () => setConfirmModalVisible(true);

  const redirect = async () => {
    await router.push(bookingData?.redirectRoute ?? '/clinician');
    await Promise.all(
      appointmentBookedQueriesToInvalidate.map((queryKey) => queryClient.invalidateQueries({ queryKey }))
    );
  };

  if (!initialised) {
    return <p>{t('Initialising ...')}</p>;
  }

  return (
    <>
      <Header pageType="clinician" pageTitle="Choose" />

      <section className="section-layout">
        <PageHead backUrl={bookingData?.redirectRoute ?? '/clinician/appointments'} backArrow backText="Back" />

        <main className="container" id="page-content">
          <SelectClinicianSlotAndConfirmBooking onSuccessBooking={onSuccessBooking} />
        </main>

        <SuccessModal
          title={'All booked'}
          subTitle={
            <SuccessBookingMessage
              apptDate={bookingData?.apptDate}
              callType={bookingData?.callType}
              clinicianName={bookingData?.clinician?.name}
            />
          }
          open={confirmModalVisible}
          onCancel={redirect}
          cancelText="Continue"
          data-testid="appointment-booked-continue-button"
        />
      </section>
    </>
  );
};


export const Route = createFileRoute('/clinician/choose')({ component: ClinicianChoose });
